import { useState, useEffect } from "react";

import {
  motion,
  //   animate,
  useMotionTemplate,
  useMotionValue,
  useTransform,
} from "framer-motion";
import { Dialog, ModalOverlay, Modal, Button } from "react-aria-components";
import { IoAttachOutline } from "react-icons/io5";

import MobileEmbedViewer from "../Actions/MobileEmbedViewer";

// Wrap React Aria modal components so they support framer-motion values.
const MotionModal = motion(Modal);
const MotionModalOverlay = motion(ModalOverlay);

// const inertiaTransition = {
//   type: "inertia",
//   bounceStiffness: 300,
//   bounceDamping: 40,
//   timeConstant: 300,
// };

const staticTransition = {
  duration: 0.5,
  ease: [0.32, 0.72, 0, 1],
};

const SHEET_MARGIN = 17;
// const SHEET_RADIUS = 12;

function SupplementalMobile({ meeting, update }) {
  const [showViewer, setShowViewer] = useState(false);
  const [linkViewer, setLinkViewer] = useState();
  const [resources, setResources] = useState([]);

  let h = window.innerHeight - SHEET_MARGIN;
  let y = useMotionValue(h);
  let bgOpacity = useTransform(y, [0, h], [0.4, 0]);
  let bg = useMotionTemplate`rgba(0, 0, 0, ${bgOpacity})`;

  useEffect(() => {
    if (meeting) {
      setResources(meeting.attachments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meeting]);

  return (
    <MotionModalOverlay
      // Force the modal to be open when AnimatePresence renders it.
      isOpen
      // onOpenChange={visible}
      className="fixed inset-0 z-10"
      style={{ backgroundColor: bg }}
    >
      <MotionModal
        className="bg-white absolute w-full bottom-0 rounded-t-xl shadow-lg"
        initial={{ y: h }}
        animate={{ y: 0 }}
        exit={{ y: h }}
        transition={staticTransition}
        style={{
          y,
          top: SHEET_MARGIN,
          // Extra padding at the bottom to account for rubber band scrolling.
          paddingBottom: window.screen.height,
        }}
        // drag="y"
        // dragConstraints={{ top: 0 }}
        // onDragEnd={(e, { offset, velocity }) => {
        //   if (offset.y > window.innerHeight * 0.75 || velocity.y > 10) {
        //     visible(false);
        //   } else {
        //     animate(y, 0, { ...inertiaTransition, min: 0, max: 0 });
        //   }
        // }}
      >
        {/* drag affordance */}
        {/* <div className="mx-auto w-12 mt-2 h-1.5 rounded-full bg-gray-400" /> */}
        <Dialog className="px-4 pb-4 outline-none">
          <div className="flex justify-end mt-1.5">
            <Button
              className="text-blue-600 font-semibold mb-4 outline-none rounded data-[pressed]:text-blue-700 data-[focus-visible]:ring"
              onPress={() => update({ visible: false, meeting: null })}
            >
              Done
            </Button>
          </div>
          <div className="border-b border-gray-400 mb-2">
            <p className="font-sm font-medium mb-0.5">
              {meeting?.scheduleDate} Supplemental Resources
            </p>
          </div>
          <div className="h-screen flex flex-col overflow-hidden">
            <div className="flex-1 px-2 pb-[400px] overflow-y-auto">
              {showViewer && (
                <MobileEmbedViewer
                  urlFile={linkViewer}
                  isVisible={setShowViewer}
                />
              )}
              {!showViewer && (
                <>
                  {resources.map((item, index) => {
                    return (
                      <div
                        className="px-2 py-2 rounded-md flex items-center space-x-2 hover:bg-blue-300 transform duration-300 group"
                        key={index}
                        onClick={() => {
                          setLinkViewer(item);
                          setShowViewer(true);
                        }}
                      >
                        <IoAttachOutline className="flex-shrink-0 h-5 w-5 text-black group-hover:text-zinc-900" />
                        <p className="text-sm font-medium text-black group-hover:text-zinc-900">
                          {item.fileName}
                        </p>
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </Dialog>
      </MotionModal>
    </MotionModalOverlay>
  );
}

export default SupplementalMobile;
